export const allEntitiesSummaryTableColumns = [
  { title: 'Entity', key: 'name', keySort: 'name' },
  { title: 'Entity Value', key: 'totalEntityValue', keySort: 'totalEntityValue' },
  { title: '% To Private Capital', key: 'privateCapitalPercentage', keySort: 'privateCapitalPercentage' },
  { title: 'Current Nav', key: 'currentNAV', keySort: 'currentNAV' },
  { title: 'Unfunded Commitment', key: 'unfundedCommitment', keySort: 'unfundedCommitment' },
  { title: 'Capacity Calculation', key: 'targetOverCommitmentRatio', keySort: 'targetOverCommitmentRatio' },
  { title: 'Capacity', key: 'capacity', keySort: 'capacity' }
];

export const overCommitmentRatioModeSummaryTableColumns = [
  { title: 'Asset Class', key: 'name', width: 20, keySort: 'asset class' },
  { title: 'Target%', key: 'percentage', width: 20, keySort: 'target %' },
  { title: 'Target Allocation', key: 'targetAllocation', width: 20, keySort: 'target allocation' },
  { title: 'Economic Exposure', key: 'economicExposure', width: 20, keySort: 'economic exposure' },
  { title: 'Capacity', key: 'capacity', width: 20, keySort: 'capacity' }
];

export const pacingModelModeSummaryTableColumns = [
  { title: 'Asset Class', key: 'name', width: 20, keySort: 'asset class' },
  { title: 'Target%', key: 'percentage', width: 20, keySort: 'target %' },
  { title: 'Target Allocation', key: 'targetAllocation', width: 20, keySort: 'target allocation' },
  { title: 'Current Nav', key: 'currentNAV', width: 20, keySort: 'current nav' },
  { title: 'Unfunded Commitment', key: 'unfundedCommitments', width: 20, keySort: 'unfunded commitment' },
  { title: 'Capacity', key: 'capacity', width: 20, keySort: 'capacity' }
];

// export const overCommitmentRatioModeSimplifiedSummaryTableColumns = [
//   { title: 'Asset Class', key: null as any, width: 50, keySort: 'asset class' },
//   { title: 'Economic Exposure', key: null, width: 50, keySort: 'economic exposure' }
// ];

export const pacingModelModeSimplifiedSummaryTableColumns = [
  { title: 'Asset Class', key: 'name', width: 33, keySort: 'asset class' },
  { title: 'Current NAV', key: 'currentNAV', width: 33, keySort: 'current NAV' },
  { title: 'Unfunded Commitment', key: 'unfundedCommitments', width: 33, keySort: 'unfunded commitment' }
];

export const allEntitiesSummaryMobileTableSort = [
  {
    title: 'Entity • A -> Z',
    key: 'name',
    asc: true
  },
  {
    title: 'Entity • Z -> A',
    key: 'name',
    asc: false
  },
  {
    title: 'Entity Value • Max -> Min',
    key: 'totalEntityValue',
    asc: false
  },
  {
    title: 'Entity Value • Min -> Max',
    key: 'totalEntityValue',
    asc: true
  },
  {
    title: '% To Private Capital • Max -> Min',
    key: 'privateCapitalPercentage',
    asc: false
  },
  {
    title: '% To Private Capital • Min -> Max',
    key: 'privateCapitalPercentage',
    asc: true
  },
  {
    title: 'Current Nav • Max -> Min',
    key: 'currentNAV',
    asc: false
  },
  {
    title: 'Current Nav • Min -> Max',
    key: 'currentNAV',
    asc: true
  },
  {
    title: 'Unfunded Commitment • Max -> Min',
    key: 'unfundedCommitment',
    asc: false
  },
  {
    title: 'Unfunded Commitment • Min -> Max',
    key: 'unfundedCommitment',
    asc: true
  },
  {
    title: 'Capacity Calculation • A -> Z',
    key: 'targetOverCommitmentRatio',
    asc: true
  },
  {
    title: 'Capacity Calculation • Z -> A',
    key: 'targetOverCommitmentRatio',
    asc: false
  },
  {
    title: 'Capacity • Max -> Min',
    key: 'capacity',
    asc: false
  },
  {
    title: 'Capacity • Min -> Max',
    key: 'capacity',
    asc: true
  }
];

export const allEntitiesSummaryDisregardAllocationTargetsMobileTableSort = [
  {
    title: 'Entity • A -> Z',
    key: 'name',
    asc: true
  },
  {
    title: 'Entity • Z -> A',
    key: 'name',
    asc: false
  },
  {
    title: 'Current Nav • Max -> Min',
    key: 'currentNAV',
    asc: false
  },
  {
    title: 'Current Nav • Min -> Max',
    key: 'currentNAV',
    asc: true
  },
  {
    title: 'Unfunded Commitment • Max -> Min',
    key: 'unfundedCommitment',
    asc: false
  },
  {
    title: 'Unfunded Commitment • Min -> Max',
    key: 'unfundedCommitment',
    asc: true
  }
];
